import { Directive, ElementRef, Input, OnInit } from '@angular/core';

import { CalenderEventCategories } from 'src/app/core/api/models';

@Directive({
  selector: '[calendarEventIcon]',
  standalone: true,
})
export class CalendarEventIconDirective implements OnInit {
  @Input('calendarEventIcon') eventCategory: CalenderEventCategories;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'mdi mdi-circle tw-text-xs ';

    switch (this.eventCategory) {
      case CalenderEventCategories.Ancient:
        classList += 'tw-text-indigo-600 dark:tw-text-indigo-600';
        break;
      case CalenderEventCategories.Astronomical:
        classList += 'tw-text-blue-500 dark:tw-text-blue-800';
        break;
      case CalenderEventCategories.International:
        classList += '!tw-text-red-500 dark:text-danger';
        break;
      case CalenderEventCategories.National:
        classList += 'tw-text-green-500 dark:tw-text-green-600';
        break;
      case CalenderEventCategories.Other:
        classList += 'tw-text-amber-500 dark:tw-text-amber-600';
        break;
      case CalenderEventCategories.Religious:
        classList += 'tw-text-sky-800 dark:tw-text-sky-700';
        break;
      default:
        break;
    }

    return classList;
  }
}
